import { FC, useEffect, useCallback } from 'react';
import { PageViewportLayout } from '../template';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { ExploreButtonFilled, ExploreButtonHollow } from 'shared/pages/explore/styles';
import { useHistory } from 'react-router-dom';
import { AppTester } from 'supporting';
import { LayoutConst } from 'core';
import { PROJECT_VOTE_STATUS } from 'core/providers/VoteProvider';

const MainTitle = styled(FInter.MainTitleSmall)`
    font-size: 30px;
    line-height: 40px;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
      font-size: 23px;
      line-height: 29px;
      margin-bottom: 40px;
    }
`;

const SecondTitle = styled(FlexBox)`
    font-size: 17px;
    line-height: 22px;
    color: ${Colors.galBlack47};
    transition: color 0.2s;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
      font-size: 15px;
      line-height: 20px;
      display: none;
    }

    :hover {
      color: #545453;
      transition: color 0.2s;
    }
`;

const ButtonBack = styled(ExploreButtonHollow)`
    max-width: 187px;
    min-width: 187px !important;
    width: 187px;
    height: 38px !important;
`;

const ButtonMain = styled(ExploreButtonFilled)`
max-width: 142px;
min-width: 142px !important;
width: 142px;
margin-left: 0 !important;
height: 38px !important;
`;


export const VoteEnd: FC<{ text: string, link: string, onToggleStatus?: (status: string) => void }> = ({ text, link, onToggleStatus }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const theme = useTheme();
  const isHseDesign = AppTester.isHSEDesign();

  const hide = useCallback(() => {
    onToggleStatus && onToggleStatus(PROJECT_VOTE_STATUS.continue);
  }, [onToggleStatus])

  const onClick = (ev: any) => {
    ev.preventDefault();
    ev.stopPropagation();
    hide();
    history.push(CreateLinkTo.competition(link))
  }

  useEffect(() => {
    return () => {
      hide();
    }
  }, [])

  const mainLink = isHseDesign ? `${CreateLinkTo.explore()}competitions?page=1&tab=partners_hse` : CreateLinkTo.explore();

  return (
    <PageViewportLayout offsetTop={180} justify={'center'} align={'center'}>
      <MainTitle color={theme.errorModal.textColorSecond}>{t('project_edit.frames.competition_vote_end')}</MainTitle>
      <SecondTitle offsetTop={16} offsetBottom={40}>
        <a onClick={onClick}>{text}</a>
      </SecondTitle>
      <FlexBox gx={24} offsetLeftMobile={30} offsetRightMobile={30} widthMobile={320} alignMobile='center' justify='center'>
        <ButtonBack onClick={() => {
          hide();
        }}>{t('t.GoBack')}</ButtonBack>
        <ButtonMain onClick={() =>{
          window.open(mainLink, '_SELF')
        }}>{t('t.GoMain')}</ButtonMain>
      </FlexBox>
    </PageViewportLayout>
  );
};
import { FC, useEffect, useCallback } from 'react';
import { PageViewportLayout } from '../template';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { ExploreButtonFilled, ExploreButtonHollow } from 'shared/pages/explore/styles';
import { useHistory } from 'react-router-dom';
import { AppTester } from 'supporting';
import { LayoutConst } from 'core';
import { PROJECT_VOTE_STATUS } from 'core/providers/VoteProvider';

const MainTitle = styled(FInter.MainTitleSmall)`
    font-size: 30px;
    line-height: 40px;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
      font-size: 23px;
      line-height: 29px;
      margin-bottom: 40px;
    }
`;

const SecondTitle = styled(FlexBox)`
    font-size: 17px;
    line-height: 22px;
    color: ${Colors.galBlack47};
    transition: color 0.2s;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
      font-size: 15px;
      line-height: 20px;
      display: none;
    }

    :hover {
      color: #545453;
      transition: color 0.2s;
    }
`;

const ButtonBack = styled(ExploreButtonHollow)`
    max-width: 187px;
    min-width: 187px !important;
    width: 187px;
    height: 38px !important;
`;

const ButtonMain = styled(ExploreButtonFilled)`
max-width: 142px;
min-width: 142px !important;
width: 142px;
margin-left: 0 !important;
height: 38px !important;
`;


export const VoteEnd: FC<{ text: string, link: string, onToggleStatus?: (status: string) => void }> = ({ text, link, onToggleStatus }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const theme = useTheme();
  const isHseDesign = AppTester.isHSEDesign();

  const hide = useCallback(() => {
    onToggleStatus && onToggleStatus(PROJECT_VOTE_STATUS.continue);
  }, [onToggleStatus])

  const onClick = (ev: any) => {
    ev.preventDefault();
    ev.stopPropagation();
    hide();
    history.push(CreateLinkTo.competition(link))
  }

  useEffect(() => {
    return () => {
      hide();
    }
  }, [])

  const mainLink = isHseDesign ? `${CreateLinkTo.explore()}competitions?page=1&tab=partners_hse` : CreateLinkTo.explore();

  return (
    <PageViewportLayout offsetTop={180} justify={'center'} align={'center'}>
      <MainTitle color={theme.errorModal.textColorSecond}>{t('project_edit.frames.competition_vote_end')}</MainTitle>
      <SecondTitle offsetTop={16} offsetBottom={40}>
        <a onClick={onClick}>{text}</a>
      </SecondTitle>
      <FlexBox gx={24} offsetLeftMobile={30} offsetRightMobile={30} widthMobile={320} alignMobile='center' justify='center'>
        <ButtonBack onClick={() => {
          hide();
        }}>{t('t.GoBack')}</ButtonBack>
        <ButtonMain onClick={() =>{
          window.open(mainLink, '_SELF')
        }}>{t('t.GoMain')}</ButtonMain>
      </FlexBox>
    </PageViewportLayout>
  );
};
